import { useEffect, useRef, useState } from "react";
import { FileUploader } from "../../../../../../components/FileUploader/FileUploader";
import * as XLSX from "xlsx";

import "./ReceivingUploadFile.scss";
import Input from "../.../../../../../../../components/Inputs/Input";

export const ReceivingUploadFile = () => {
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const tbodyRef = useRef(null);
  const [hasScroll, setHasScroll] = useState(false);

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length) {
        setColumns(jsonData[0]);
        setTableData(jsonData.slice(1));
      }
    };
    reader.readAsArrayBuffer(file);
  };

  useEffect(() => {
    if (tbodyRef.current) {
      const el = tbodyRef.current;
      setHasScroll(el.scrollHeight > el.clientHeight);
    }
  }, [tableData]);

  return (
    <section className="receiving-uploadFile">
      <nav className="receiving-uploadFile-header">
        <h2>Import File (NLA)</h2>
        <button>Ingest File</button>
      </nav>
      <section className="receiving-uploadFile-fileComponent-cont">
        <div
          style={{
            width: "30%",
            height: "80%",
          }}
        >
          <FileUploader
            label={"Upload NLA File"}
            onUpload={(e) => {
              const file = e.target.files[0];
              if (file) {
                handleFileUpload(file);
              }
            }}
          ></FileUploader>
        </div>
      </section>
      <div>
        <h3>Preview File</h3>
        <h3>Columns mapping</h3>
      </div>
      <section className="receiving-uploadFile-table-parent-cont">
        <div
          className="receiving-uploadFile-table-preview"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {columns.length > 0 ? (
            <table>
              <thead>
                <tr>
                  {columns.map((col, idx) => (
                    <th key={idx}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody ref={tbodyRef} className={hasScroll ? "with-scroll" : ""}>
                {tableData.map((row, rIdx) => (
                  <tr key={rIdx}>
                    {columns.map((_, cIdx) => (
                      <td className="ellipsis" key={cIdx}>
                        {row[cIdx] ?? ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: "var(--black-mid)" , fontWeight : "500" }}>Upload File To preview.</p>
          )}
        </div>
        <div className="receiving-uploadFile-columns-map-cont">
          <nav>
            <p>ID</p>
            <p>Column Name</p>
            <p>Kodo Field</p>
          </nav>
          <section>
            <div>
              <p style={{ width: "10%" }}>A</p>
              <p style={{ width: "40%" }}>PN</p>
              <Input style={{ width: "50%" }} label={"PN"}></Input>
            </div>
             <div>
              <p style={{ width: "10%" }}>A</p>
              <p style={{ width: "40%" }}>PN</p>
              <Input style={{ width: "50%" }} label={"PN"}></Input>
            </div>
             <div>
              <p style={{ width: "10%" }}>A</p>
              <p style={{ width: "40%" }}>PN</p>
              <Input style={{ width: "50%" }} label={"PN"}></Input>
            </div>
             <div>
              <p style={{ width: "10%" }}>A</p>
              <p style={{ width: "40%" }}>PN</p>
              <Input style={{ width: "50%" }} label={"PN"}></Input>
            </div>
          </section>
        </div>
      </section>
    </section>
  );
};
